// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytical-data .searchDate .date-range input {
  padding: 6px 10px;
  border: 1px solid lightgray;
  border-radius: 3px;
  width: 130px;
}

.react-datepicker-wrapper {
  width: auto;
}

/* Fix calendar transparency and visibility */
.react-datepicker {
  background-color: #fff !important;
  border: 1px solid #aeaeae !important;
  z-index: 9999 !important;
}

.react-datepicker__header {
  background-color: #f0f0f0 !important;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}

.analytical-data .spinner-container {
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: center;
}
.analytical-data .spinner {
  margin: auto;
  border: 5px solid #dbf2ff;
  /*
    change to dotted for something cool.
    change width to 1px for tapered bar
    */
  width: 52px;
  height: 52px;
  display: inline-block;
  position: absolute;
  top: 45%;
  border-radius: 50%;
  border-right: 5px solid #018df7;
  text-align: center;
  animation-name: spin;
  animation-duration: 900ms;
  animation-iteration-count: infinite;
  /*animation-timing-function: linear; /*linear spin */
  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  /*50% {width:24px;height:24px} /*shrinking effect*/
  100% {
    -webkit-transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/statisticPage/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;EACjC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB;;;KAGG;EACH,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;EACnC,oDAAoD;EACpD,+DAA+D;AACjE;AAUA;EACE;IACE,+BAA+B;EACjC;EACA,kDAAkD;EAClD;IACE,iCAAiC;EACnC;AACF","sourcesContent":[".analytical-data .searchDate .date-range input {\r\n  padding: 6px 10px;\r\n  border: 1px solid lightgray;\r\n  border-radius: 3px;\r\n  width: 130px;\r\n}\r\n\r\n.react-datepicker-wrapper {\r\n  width: auto;\r\n}\r\n\r\n/* Fix calendar transparency and visibility */\r\n.react-datepicker {\r\n  background-color: #fff !important;\r\n  border: 1px solid #aeaeae !important;\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.react-datepicker__header {\r\n  background-color: #f0f0f0 !important;\r\n}\r\n\r\n.react-datepicker-popper {\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.analytical-data .spinner-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 99999;\r\n  text-align: center;\r\n}\r\n.analytical-data .spinner {\r\n  margin: auto;\r\n  border: 5px solid #dbf2ff;\r\n  /*\r\n    change to dotted for something cool.\r\n    change width to 1px for tapered bar\r\n    */\r\n  width: 52px;\r\n  height: 52px;\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 45%;\r\n  border-radius: 50%;\r\n  border-right: 5px solid #018df7;\r\n  text-align: center;\r\n  animation-name: spin;\r\n  animation-duration: 900ms;\r\n  animation-iteration-count: infinite;\r\n  /*animation-timing-function: linear; /*linear spin */\r\n  animation-timing-function: cubic-bezier(0.53, 0.21, 0.29, 0.67);\r\n}\r\n@-webkit-keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n  /*50% {width:24px;height:24px} /*shrinking effect*/\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n  /*50% {width:24px;height:24px} /*shrinking effect*/\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
